import {ActionCreator, createReducer} from '../../store/utils';

import type {Action} from '../../store/utils';

export type TierRestrictionState = {
  tierRestrictionModalOpen: boolean,
};

export type TierRestrictionAction = Action & {
  tierRestrictionModalOpen?: boolean,
};

export class SetTierRestrictionModalOpenAction extends ActionCreator<TierRestrictionAction> {}

export const actions = {
  openTierRestrictionModal: () =>
    new SetTierRestrictionModalOpenAction({tierRestrictionModalOpen: true}),

  closeTierRestrictionModal: () =>
    new SetTierRestrictionModalOpenAction({tierRestrictionModalOpen: false}),
};

export const initialState: TierRestrictionState = {
  tierRestrictionModalOpen: false,
};

export default createReducer(initialState, {
  [SetTierRestrictionModalOpenAction.type]: (state, action) => ({
    ...state,
    tierRestrictionModalOpen: action.tierRestrictionModalOpen,
  }),
});
